import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LinkCards, Modal } from 'br2s-ui-componentlibrary_r2_02';
import { LOGIN_TYPE } from '@/utilities/constants';
import { AuthAPI } from '@/services/api/auth';
import {
  useHTTPError,
  HTTPErrorAlertContainer,
  LocalStorageService,
  reportDtCustomError,
} from 'br2s-ui-common-utils-02';

import './Login.scss';
import { useStore } from '@/redux/store';

export type LoginType = 'Individual' | 'Business';

interface LoginProps {
  setLoginModal: (show: boolean) => void;
}

const Login = ({ setLoginModal }: LoginProps) => {
  const { auth, toggleSfvAttempt } = useStore();
  const { handleHTTPError } = useHTTPError();
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.previousUrl !== undefined) {
      LocalStorageService.setUrlPriorToLogin(location.state.previousUrl);
    }
  }, []);

  const handleLogin = async (type: LoginType) => {
    try {
      const sfv = type === 'Individual' && auth.sfvAttempted;
      const response = await AuthAPI.getKickoffRedirectUrl({
        loginType: type,
        ...(sfv ? { sfv } : {}),
      });

      if (response?.status === 200) {
        const { kickOffUrl } = response.data.result;
        window.open(kickOffUrl, '_self');
      }
    } catch (error) {
      console.error(error);
      reportDtCustomError('GenericHandledError', JSON.stringify(error));

      // istanbul ignore next
      handleHTTPError(error, {
        errorType: 'inline',
      });
    } finally {
      toggleSfvAttempt(false);
    }
  };

  const closeModal = () => {
    toggleSfvAttempt(false);
    LocalStorageService.clearUrlPriorToLogin();
    setLoginModal(false);
  };

  return (
    <div>
      <Modal
        id="login-modal"
        isOpen={true}
        onCloseClick={closeModal}
        size="medium"
        title="Login"
        children={
          <div className="link-buttons">
            <HTTPErrorAlertContainer />
            <div
              className="login-business"
              onClick={() => {
                handleLogin(LOGIN_TYPE.BUSINESS as LoginType);
              }}
            >
              <LinkCards
                id="business-login"
                title="Business User"
                cardSize="xlarge"
                description="Login with UEN, Corppass to transact on behalf of a business entity."
                href="#"
              />
            </div>
            <div
              className="login-individual"
              onClick={() => {
                handleLogin(LOGIN_TYPE.INDIVIDUAL as LoginType);
              }}
            >
              <LinkCards
                id="individual-login"
                title="Individual User"
                cardSize="xlarge"
                description="Login with Singpass to transact as an individual without a registered UEN."
                href="#"
              />
            </div>
            {process.env.REACT_APP_SHOW_MOCK_SPCP?.toString() === 'true' && (
              <div
                className="login-mock"
                onClick={() => {
                  window.location.href = `${process.env.REACT_APP_SHELL_MFE_URL}/mockspcp`;
                  setLoginModal(false);
                }}
              >
                <LinkCards
                  id="mock-login"
                  title="Mock Login"
                  cardSize="xlarge"
                  description="Mock login with Singpass or Corpass to transact as individual or business user."
                  href="#"
                />
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};

export default Login;
